export class TaskPromise extends Promise {
  /**
   * @type {Promise<*>}
   */
  promise = null;

  /**
   * @var {boolean}
   */
  resolved = false;

  /**
   * @var {boolean}
   */
  pending = false;

  /**
   * @var {boolean}
   */
  rejected = false;

  constructor(promise) {
    // Since migrating to vite-js an anonymous fn gets passed here for some reason
    if (typeof promise === 'function') {
      promise = new Promise(promise);
    }

    let resolve = null;
    let reject = null;
    super((resolveFn, rejectFn) => {
      resolve = resolveFn;
      reject = rejectFn;
    });

    this.promise = promise;
    this.pending = true;
    this.resolve = resolve;
    this.reject = reject;

    promise.then((response) => {
      this.resolved = true;
      this.resolve(response);
    });
    promise.catch((response) => {
      this.rejected = true;
      this.reject(response);
    });
    promise.finally(() => {
      this.pending = false;
    });
  }

  /**
   * @returns {boolean}
   */
  isDone() {
    return !this.pending && (this.rejected || this.resolved);
  }
}
